import { render } from "./DetalharPessoaFisica.vue?vue&type=template&id=a4bb7574&scoped=true"
import script from "./DetalharPessoaFisica.vue?vue&type=script&lang=js"
export * from "./DetalharPessoaFisica.vue?vue&type=script&lang=js"

import "./DetalharPessoaFisica.vue?vue&type=style&index=0&id=a4bb7574&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bb7574"]])

export default __exports__